export default __webpack_public_path__ + "static/media/cafesrec2.33717634.jpeg";